import uniqBy from 'lodash/uniqBy'
export default function() {
	const { order, injured, setting } = this
	let mediaInfoList = []
	let list = [
		{ type: 'h01', picName: '医院1' },
		{ type: 'h02', picName: '医院2' },
		{ type: 'h03', picName: '医院3' },
		{ type: 'h04', picName: '医院4' },
		{ type: 'h05', picName: '医院5' },
	]
	injured.mediaInfoList &&
		injured.mediaInfoList.forEach(item => {
			list.forEach(items => {
				if (item.type == items.type) {
					mediaInfoList.push(items)
				}
			})
		})
	let mediaList = []
	if (this.isInHospital) {
		mediaList =
			uniqBy(mediaInfoList, 'type').length > 0
				? uniqBy(mediaInfoList, 'type')
				: [{ type: 'h01', picName: '医院1' }]
	} else {
		mediaList = [{ type: '7002', picName: '关键证据材料' }]
	}
	let arr = [
		{
			title: '调查过程环境',
			children: [{ type: '7001', picName: '调查过程环境照片' }],
		},
		{
			title: '关键证据材料',
			// children: [{ type: '7002', picName: '关键证据材料' }],
			children: mediaList,
		},
	]
	if (this.isOtherInvestigate && this.isWholeProcesDepth) {
		arr.push({
			title: '调查报告',
			slot: 'reportList',
			children: [{ type: 'report', picName: '调查报告' }],
		})
	}
	if (this.isOtherInvestigate && !this.isWholeProcesDepth) {
		arr.push({
			title: '调查报告',
			desc: '（非必传）',
			slot: 'reportList',
			children: [{ type: 'report', picName: '调查报告' }],
		})
	}
	arr.push(
		{
			title: '电子签名',
			slot: 'sign',
		},
		{
			title: '签到',
			children: [{ type: '7000', picName: '调查场所入口签到' }],
		},
		{
			title: '笔录',
			desc: '（非必传）',
			children: [{ type: '7003', picName: '笔录' }],
		},
		{
			title: '其他',
			desc: '（非必传）',
			children: [{ type: '0900', picName: '其他' }],
		}
	)
	if (this.isOtherInvestigate) {
		arr.push({
			title: '录音',
			desc: '（非必传）',
			slot: 'audioList',
			children: [{ type: 'audio', picName: '录音' }],
		})
	}
	arr.push({
		title: '视频信息',
		desc: '（非必传）',
		slot: 'videoList',
	})

	return arr
}
